import { ProfileAddress } from "./ProfileAddress";

export default ProfileAddress;
